"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceNumberRequest = void 0;
var ServiceNumberRequest = /** @class */ (function () {
    function ServiceNumberRequest() {
    }
    return ServiceNumberRequest;
}());
exports.ServiceNumberRequest = ServiceNumberRequest;
;
//# sourceMappingURL=serviceNumber.request.js.map